'use client';
import { useState } from 'react';

const GPlusIcon = () => {
  const [iconColor, setIconColor] = useState('url(#paint0_linear_0_255)');

  const handleMouseEnter = () => {
    setIconColor('#FFFFFF');
  };

  const handleMouseLeave = () => {
    setIconColor('url(#paint0_linear_0_255)');
  };

  const handleClick = () => {
    setIconColor('#064E3B');
    setTimeout(() => {
      window.open('https://plus.google.com/your_profile', '_blank', 'noopener,noreferrer');
    }, 500);
  };

  return (
    <div
      className="ml-3 group cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-colors duration-200"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 6C2 3.79086 3.79086 2 6 2H17.55C19.7591 2 21.55 3.79086 21.55 6V17.55C21.55 19.7591 19.7591 21.55 17.55 21.55H6C3.79086 21.55 2 19.7591 2 17.55V6ZM9.59 11.06V12.62H11.78C11.5031 13.6137 10.5809 14.2878 9.55 14.25C8.18585 14.25 7.08 13.1441 7.08 11.78C7.08 10.4159 8.18585 9.31 9.55 9.31C10.1396 9.30985 10.7101 9.51892 11.16 9.9L12.35 8.78C11.0022 7.52457 8.98256 7.32207 7.41231 8.28491C5.84206 9.24775 5.10665 11.1396 5.61432 12.9102C6.12199 14.6808 7.74812 15.8955 9.59 15.88C10.7958 15.8938 11.9408 15.3518 12.6945 14.4106C13.4483 13.4694 13.7269 12.2336 13.45 11.06H9.59ZM16.77 11.32H18.07V12.24H16.77V13.54H15.86V12.24H14.56V11.32H15.86V10.02H16.77V11.32Z"
          fill={iconColor}
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_255"
            x1="2"
            y1="11.6915"
            x2="21.55"
            y2="11.6915"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#27FF7D" />
            <stop offset="1" stopColor="#18994B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default GPlusIcon;
